import React, { useRef, useEffect, useState } from "react";
import axios from "axios";
import "./kundaliChart.scss"; // reuse same css

export default function KundaliLagna({ date }) {
  const canvasRef = useRef(null);
  const [houses, setHouses] = useState({});
  const [ascSign, setAscSign] = useState(null);

  // Slots (same North Indian style)
  const houseSlots = {
    1: [[10, 50], [30, 80], [30, 110]],     
    2: [[110, 220], [160, 200], [110, 240]],
    3: [[340, 300], [310, 300], [340, 280]],
    4: [[320, 110], [340, 110], [360, 140], [370, 120]],
    5: [[190, 230], [190, 250]],
    6: [[290, 360], [290, 320], [290, 340]],
    7: [[20, 290], [60, 300]],
    8: [[90, 330], [110, 330], [50, 330]],
    9: [[240, 200], [210, 210], [180, 220]],
    10: [[290, 50], [290, 70]],
    11: [[200, 90], [200, 120], [180, 170]],
    12: [[80, 50], [80, 30], [80, 80]],
  };

  // Fetch Lagna data
  useEffect(() => {
        if (!date ) return ("problem in paradise");

    axios
      .get("https://core-c343.onrender.com/api/lagna-chart", {
        params: {
          year: date.getFullYear(),
          month: date.getMonth() + 1,
          day: date.getDate(),
          hour: date.getHours(),
          minute: date.getMinutes(),
          timezone: "Asia/Kolkata",
          
        },
      })
      .then((res) => {
        const data = res.data;

        // API gives planetToHouseMap directly
        const planetMap = data.planetToHouseMap;
        const houseData = {};

        Object.keys(planetMap).forEach((planet) => {
          const houseNum = planetMap[planet];
          if (!houseData[houseNum]) houseData[houseNum] = [];
          houseData[houseNum].push({ name: planet });
        });

        setHouses(houseData);

        // Ascendant = house 1 (we don’t need to rotate like Navamsa, API already gives it)
        setAscSign(1);
      })
      .catch((err) => {
        console.error("Error fetching lagna chart:", err);
      });
  }, [date]);

  // Draw chart
  useEffect(() => {
    if (!canvasRef.current || Object.keys(houses).length === 0 || !ascSign)
      return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Outer diamond
    ctx.beginPath();
    ctx.moveTo(200, 0);
    ctx.lineTo(400, 200);
    ctx.lineTo(200, 400);
    ctx.lineTo(0, 200);
    ctx.closePath();
    ctx.strokeStyle = "#e8811aff";
    ctx.lineWidth = 2;
    ctx.stroke();

    // Cross lines
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(400, 400);
    ctx.moveTo(400, 0);
    ctx.lineTo(0, 400);
    ctx.stroke();

    // Planets
    Object.keys(houseSlots).forEach((slot) => {
      const items = houses[slot] || [];
      const positions = houseSlots[slot];

      items.forEach((item, idx) => {
        const pos = positions[idx] || positions[0];
        ctx.fillStyle = "black";
        ctx.font = "16px roboto";
        ctx.fillText(item.name, pos[0], pos[1]);
      });

      // House number           
      const numPos = positions[0];
      ctx.fillStyle = "orange";
      ctx.font = "12px Arial";
      ctx.fillText(slot.toString(), numPos[0], numPos[1] - 10);
    });
  }, [houses, ascSign]);

  return (
    <div className="kundalii-container" style={{ textAlign: "center" }}>
      <h3>Lagna Chart</h3>
      <canvas
        className="canvas"
        ref={canvasRef}
        width={400}
        height={400}
        style={{ border: "1px solid black" }}
      ></canvas>
    </div>
  );
}